module.exports = __webpack_public_path__ + "img/s1_SNB.1aeae831.svg";